import { getProvider, getWeb3, waitForConfirmation } from ".";
import config from "../../config/config";

import MafiaCarNickAbi from "../../abis/MafiaCarNick.json";

export const getMafiaCarNickContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.carNickAddress;
  const MafiaCarNickContract = new web3.eth.Contract(
    MafiaCarNickAbi,
    contractAddress
  );
  return MafiaCarNickContract;
};

export const nickCar = async (
  crimeType: number,
  account: string,
  signMsg: string,
  signature: string
) => {
  const MafiaCarNickContract = getMafiaCarNickContract(true);
  try {
    const data = await MafiaCarNickContract.methods
      .nickCar(crimeType, JSON.stringify(signMsg), signature)
      .send({ from: account });
    await waitForConfirmation(data.transactionHash);
    return data;
  } catch (error) {
    console.error("Error nicking the car:", error);
    throw error;
  }
};

export const getNextNickTime = async (account: string) => {
  const MafiaCarNickContract = getMafiaCarNickContract();
  const nextNickTime: number = await MafiaCarNickContract.methods
    .nextNickTime(account)
    .call({
      from: account,
    });
  return Number(nextNickTime);
};
